const SERVICES_DATA = [
  {
    icon: '🌐',
    title: 'Bespoke Web Design',
    short: 'Custom-built websites and web applications designed to reflect your brand and deliver results.',
    desc: 'We design and develop bespoke websites and web applications from the ground up. No templates, no shortcuts — every project is tailored to your brand, your audience, and your goals. Built with modern frameworks like React and .NET, our sites are fast, responsive, accessible and built to scale.',
    features: ['Custom UI/UX Design', 'React & .NET Development', 'Responsive & Accessible', 'SEO Optimised', 'CMS Integration'],
  },
  {
    icon: '⚙️',
    title: 'Bespoke Internal Systems',
    short: 'Custom software to streamline your operations — from CRMs to workflow tools, built around your processes.',
    desc: "Off-the-shelf software doesn't always fit. We design and build bespoke internal systems that match how your business actually works — whether that's a custom CRM, project management tool, booking system, or data pipeline. Built with .NET backends and modern web frontends, deployed securely to Azure.",
    features: ['Custom CRM & ERP Systems', 'Workflow Automation', 'Data Management Platforms', 'API Integrations', 'Legacy System Replacement'],
  },
  {
    icon: '☁️',
    title: 'Microsoft Azure Services',
    short: 'Architecture, migration and managed cloud services on the Microsoft Azure platform.',
    desc: 'As a Microsoft Azure specialist, we help businesses migrate to the cloud, optimise their existing Azure environments, and build cloud-native solutions. From initial architecture through to ongoing management, we ensure your cloud infrastructure is secure, performant and cost-effective.',
    features: ['Azure Architecture & Migration', 'Azure DevOps & CI/CD', 'Cost Optimisation', 'Hybrid Cloud', 'App Services & Functions'],
  },
  {
    icon: '📊',
    title: 'IT Strategy & Consulting',
    short: 'Technology roadmaps and digital transformation consulting aligned with your business goals.',
    desc: "Not sure where to start or what to prioritise? Our consulting services help you build a clear technology roadmap aligned with your business objectives. We cut through the noise and give you honest, vendor-neutral advice — whether you're planning a digital transformation or need a second opinion.",
    features: ['Technology Roadmapping', 'Digital Transformation', 'Vendor Selection', 'IT Budgeting & Planning', 'Architecture Reviews'],
  },
  {
    icon: '🛡️',
    title: 'Disaster Recovery Planning',
    short: 'Protect your business from the unexpected with robust disaster recovery and business continuity strategies.',
    desc: 'When things go wrong, preparation makes all the difference. We design and implement disaster recovery plans that ensure your critical systems and data are protected. From backup strategies to failover architectures, we help you minimise downtime and recover quickly.',
    features: ['DR Strategy & Design', 'Backup Solutions', 'Failover Architecture', 'Business Continuity Planning', 'DR Testing & Drills'],
  },
  {
    icon: '🖥️',
    title: 'Infrastructure Planning',
    short: 'Network design, server management and hybrid cloud infrastructure — built for reliability.',
    desc: "Reliable infrastructure is the backbone of your business. We design, deploy and manage networks, servers, and endpoints — on-premises, in the cloud, or hybrid. Whether you're setting up a new office or re-architecting your entire estate, we ensure it's built for performance and resilience.",
    features: ['Network Design & Management', 'Server Administration', 'Active Directory & M365', 'Virtualisation', 'Capacity Planning'],
  },
];

export default SERVICES_DATA;
